import React, { useEffect, useState } from "react";
import { quillModules, quillModulesUser } from "./helper";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Input, Card } from "antd";
const SelectedTemplateDetails = ({
  emailSingleTemplate,
  dataPassed = {},
  quillRef,
  from = "__",
  origin = "normal",
}) => {
  console.log(emailSingleTemplate);
  const [text, setText] = useState("");
  const RemoveButtons = () => {
    if (emailSingleTemplate?.body) {
      const buttonRegex = /<a.*?class="button1".*?>.*?<\/a>/g;
      const removedButtonsArray =
        emailSingleTemplate.body.match(buttonRegex) || [];
      const removedButtonsString = removedButtonsArray.join(" ");
      console.log(removedButtonsString);
      const modifiedBody = emailSingleTemplate.body.replace(buttonRegex, "");
      if (origin === "USER") {
        setText(emailSingleTemplate?.body);
      } else {
        setText(modifiedBody || "--");
      }
    } else {
      console.log("first");
    }
  };

  useEffect(() => {
    RemoveButtons();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailSingleTemplate]);
  return (
    <Card
      hoverable
      headStyle={{
        backgroundColor: from === "notifications" ? "white" : "#353935",

        padding: origin === "USER" ? "0px" : "5.5px",
      }}
      bodyStyle={{ padding: 20 }}
      title={
        origin !== "USER" ? (
          <span
            style={{
              color: from === "notifications" ? "black" : "white",
              paddingLeft: "20px",
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: from === "notifications" ? "14px" : "15px",
            }}
          >
            {/* {from === "notifications" ? "Selected Template Details : " : ""}{" "} */}
            {emailSingleTemplate?.title}{" "}
            {from === "notifications" ? "-- Information " : ""}
          </span>
        ) : null
      }
    >
      {origin !== "USER" && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div
            className="my-form-lables-withoutoverFlow"
            style={{
              fontSize: "14px",
              paddingInline: "5px",
              minWidth: "120px",
            }}
          >
            EMAIL SUBJECT :
          </div>
          <Input
            placeholder="Enter the email subject"
            className="my-form-input-antd-test-without-border"
            style={{
              marginLeft: "10px",
            }}
            value={emailSingleTemplate?.subject}
            disabled
          />
        </div>
      )}
      <ReactQuill
        theme="snow"
        value={text}
        onChange={setText}
        modules={origin === "USER" ? quillModulesUser : quillModules}
        ref={quillRef}
        readOnly={true}
        style={{
          maxHeight: "200px",
          marginBottom: "20px",
          fontFamily: "Poppins",
        }}
      />
      {dataPassed?.attachments?.length > 0 && (
        <div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: 500,
              marginBottom: "10px",
              fontFamily: "Poppins",
            }}
          >
            Attachments:
          </div>
          <ul style={{ paddingLeft: "15px" }}>
            {dataPassed?.attachments?.map((attachment, index) => (
              <li key={index} style={{ marginBottom: "5px" }}>
                <a
                  href={attachment.file_path}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1890ff",
                    textDecoration: "none",
                    fontFamily: "Poppins",
                  }}
                >
                  {attachment.file_name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Card>
  );
};

export default SelectedTemplateDetails;
